import {Box} from '@mui/material';
import {t} from 'i18next';
import './ProtocolIntelligenceHeader.scss';
import ArrButton from '../../../../common/arr-button/ArrButton';
import ArrTooltipWrapper from '../../../../common/arr-tooltip-wrapper/ArrTooltipWrapper';
import {ReactComponent as InfoIcon} from './../../../../../assets/images/info-icon.svg';
import {ReactComponent as ManageProtocolIcon} from './../../../../../assets/images/manageProtocol.svg';
import {useReviewHeaderContext} from '../../header/ReviewHeader';
import UploadButton from '../protocolIntelligenceContent/uploadProtocol/UploadButton';

const ProtocolIntelligenceHeader = () => {
  const {handleManageProtocolClose, protocolVersions = []} =
    useReviewHeaderContext();
  return (
    <Box>
      {protocolVersions.length > 0 && (
        <Box className="protocol-intelligence-drawer-actions">
          <ArrButton
            variant="secondary"
            size="medium"
            onClick={handleManageProtocolClose}
            aria-label={t('common.close')}
            tabIndex={0}
            dataTestId="protocol-intelligence-header-close-button"
          >
            {t('common.close')}
          </ArrButton>
        </Box>
      )}
      <Box className="manage-protocol-content-header">
        <Box className="manage-protocol-content-header-icon-wrapper">
          <Box className="manage-protocol-content-header-icon">
            <ManageProtocolIcon
              className=" manage-protocol-icon-header"
              data-testid=" manage-protocol-icon-header"
            />
          </Box>

          <Box className="manage-protocol-content-header-text">
            <Box
              className="manage-protocol-content-header-text-title"
              aria-label={t('ai.review.protocolIntelligence.title')}
              tabIndex={0}
            >
              {t('ai.review.protocolIntelligence.title')}{' '}
              <Box
                className="alpha-button"
                aria-label={t('ai.review.protocolIntelligence.alpha')}
                tabIndex={0}
              >
                {t('ai.review.protocolIntelligence.alpha')}
              </Box>
            </Box>

            <Box
              className="manage-protocol-content-body-text-subHeader"
              aria-label={t('ai.review.protocolIntelligence.description')}
              tabIndex={0}
            >
              {t('ai.review.protocolIntelligence.description')}
            </Box>
          </Box>
        </Box>
        {protocolVersions.length > 0 ? (
          <UploadButton
            className="upload-protocol-button"
            size="medium"
            ariaLabel={t('ai.review.protocolIntelligence.uploadProtocol')}
            tabIndex={0}
            dataTestId="upload-protocol-upload-protocol-button"
          >
            {t('ai.review.protocolIntelligence.uploadProtocol')}
          </UploadButton>
        ) : (
          <ArrButton
            variant="secondary"
            size="medium"
            onClick={handleManageProtocolClose}
            aria-label={t('common.close')}
            tabIndex={0}
            dataTestId="protocol-intelligence-header-close-button"
          >
            {t('common.close')}
          </ArrButton>
        )}
      </Box>
    </Box>
  );
};

export default ProtocolIntelligenceHeader;
